import React, { useEffect, useMemo, useState } from 'react'
import { Button, Image } from 'react-bootstrap';
import cardStars from '../../assets/images/Stars.svg';
import cardlogo from '../../assets/images/white-logo.svg';
import './MightyBucksGiftCardPage.scss';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectToken } from '../user/userSlice';
import { selectCartItems, selectCartUpdateInProgress, selectOrderInProgress, setCartItem } from '../cart/cartSlice';
import CartObj from '../cart/cartObj';
import ToastError from '../../components/ToastError';
import { selectIsMobileRoute } from '../mobile/mobileSlice';
import { selectProducts } from './productsSlice';

export default function MightyBucksGiftCardPage() {
    const allProducts: Array<Record<string, any>> = useSelector(selectProducts);
    const dispatch = useDispatch();
    const token = useSelector(selectToken);
    const navigate = useNavigate();
    const cartItems = useSelector(selectCartItems);
    const [errorMsg, setErrorMsg] = useState('');
    const [mightyBucks, setMightyBucks] = useState<any>([]);
    const [selectedProductId, setSelectedProductId] = useState([]);
    const [isAdding, setIsAdding] = useState(false);
    const cartUpdateInProgress = useSelector(selectCartUpdateInProgress);
    const orderInProgress = useSelector(selectOrderInProgress);
    const AppURL = useSelector(selectIsMobileRoute);
    const QURLParams = AppURL ? `/?${AppURL}` : '/';
    const cart = useMemo(() => {
        return new CartObj(cartItems)
    }, [cartItems]);

    useEffect(() => {
        const mightyBucksGiftCard = allProducts.filter((product) => {
            return product.slug.startsWith("mighty-bucks-gift-card-for-");
        })
        if (mightyBucksGiftCard.length > 0) {
            setMightyBucks(mightyBucksGiftCard);
        }
    }, [allProducts])

    const handleBucksGirftCards = async (price: any, CardId: number) => {
        if (!cart.isEmpty()) {
            setErrorMsg('Please clear your cart to purchase this item.');
            setTimeout(() => {
                setErrorMsg('');
            }, 5000);
        } else {
            setIsAdding(true);
            if (CardId) {
                await dispatch(setCartItem({
                    token: token,
                    cart_item: {
                        product_id: CardId,
                        product_qty: 1,
                        product_price: price
                    }
                }));
                navigate(`/checkout${QURLParams}`);
            }
            setIsAdding(false);
        }
    }

    return (
        <div className='row d-flex justify-content-center mighty-bucks'>
            {mightyBucks.map((giftCard: any, index: number) => (
                <div className={`mb-top col-xl-4 col-md-4 col-12`} key={index}>
                    <div className='mb-bg-wrap'>
                        <div className='mb-bg-image'>
                            <Image
                                src={cardStars}
                                loading="lazy"
                            />
                        </div>
                        <div className='mb-top-wrap'>
                            <div className='mb-left'>
                                <div className='mb-bg-gradient'></div>
                                <div className='mb-img-content'>
                                    <div className='mb-img-top'>
                                        <div className='mb-logo'>
                                            <Image
                                                src={cardlogo}
                                                loading="lazy"
                                                alt="MightyMeals Logo"
                                            />
                                        </div>
                                        <h6 className='mb-gift'>Gift Card</h6>
                                    </div>
                                    <div className='mb-img-bottom'>
                                        <div className='mb-price'>${giftCard?.regular_price}</div>
                                        <div className='mb-subtitle'>Mightybucks</div>
                                    </div>
                                </div>
                            </div>
                            <div className='mb-right'>
                                <div className={`mb-img-wrap ${giftCard.slug === 'gift-card' ? 'gift-img-wrap' : ''}`}>
                                    <img src={giftCard.images[0].src} loading="lazy" alt='meal' />
                                </div>
                            </div>
                        </div>
                    </div>
                    {selectedProductId === giftCard.id && errorMsg &&
                        <ToastError
                            msg={errorMsg}
                            onClose={() => setErrorMsg('')}
                            position="middle-center"
                        />
                    }
                    <div className='mb-line'></div>
                    <div className='mb-content-block'>
                        <p className='pb-0'>Buy <span className='font-barlow'>$</span>{giftCard?.regular_price} worth of MightyBucks for
                            <span className='font-barlow'> $</span>{giftCard?.price}</p>
                        <p className='fw-bolder'>{giftCard.meta_data.map((metaItems: any, idx: number) => (
                            metaItems.key === 'gift_card_discount_note' && <span key={idx} className='fs-23px fw-bold'> {metaItems.value} Discount</span>
                        ))}</p>
                        <Button
                            variant="success"
                            size="sm"
                            disabled={orderInProgress || cartUpdateInProgress || isAdding}
                            onClick={() => {
                                setSelectedProductId(giftCard.id);
                                handleBucksGirftCards(giftCard?.price, giftCard.id);
                            }}>
                            PURCHASE
                        </Button>
                    </div>
                </div>
            ))}
        </div>
    )
}